import { isResource } from '@medplum/core'
import type { ClientApplication } from '@medplum/fhirtypes'
import { ExtendedResource } from '#src/ExtendedResource.ts'
import { invariant } from '#src/invariant.ts'
import { isOfType } from '#src/utils.ts'

export class ExtendedClientApplication extends ExtendedResource<ClientApplication> {
  static readonly RESOURCE_TYPE = 'ClientApplication'

  static isInstance(value: unknown): value is ClientApplication {
    return isResource(value) && isOfType(value, 'ClientApplication')
  }

  static get companyName(): string {
    // TODO: Correctly display a variable company name.
    return 'Seen Health'
  }

  get name(): string {
    invariant(this.resource.name, `${this.reference.reference} has no name`)
    return this.resource.name
  }

  get initials(): string {
    const nameParts = this.name.trim().split(/\s+/)
    if (nameParts.length >= 2) {
      return (
        nameParts[0][0] + nameParts[nameParts.length - 1][0]
      ).toUpperCase()
    }
    return nameParts[0][0].toUpperCase()
  }
}
